<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="문서명"
            name="documentTitle"
            v-model="searchParam.documentTitle">
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 관련공정 -->
          <c-process
            label="LBL0001705"
            multiple="single"
            name="processCd"
            type="upprocess"
            v-model="searchParam.processCd">
          </c-process>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 관리부서 -->
          <c-dept
            type="search"
            label="LBL0001721"
            name="deptCd"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사용여부 -->
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="LBLUSEFLAG"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!-- + 목록-->
    <c-table
      ref="table"
      :title="documentInfo.title + ' ' + $label('LBLLIST')" 
      tableId="processManual"
      :columns="grid.columns" 
      :gridHeight="grid.height"
      :data="grid.data"
      rowKey="psiPowerEquipmentId"
      :columnSetting="false"
      :expandAll="true"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 등록 -->
          <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="linkClick" />
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';

export default {
  name: 'pid-master',

  props: {
    documentInfo: {
      type: Object,
      default(){
        return {
          documentClassCd: '',
          title: '',
        }
      },
    },
  },
  data() {
    return {
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            // 사업장
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:100px',
          },
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: 'Rev.',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
          {
            name: 'documentTitle',
            field: 'documentTitle',
            // 문서명
            label: 'LBL0010460',
            align: 'left',
            type: "link",
          },
          {
            name: 'deptName',
            field: 'deptName',
            // 관리부서
            label: 'LBL0001721',
            align: 'center',
            style: 'width:150px',
          },
          {
            name: 'processName',
            field: 'processName',
            // 관련공정
            label: 'LBL0001705',
            align: 'center',
            style: 'width:200px',
          },
          {
            name: 'sopMocId',
            field: 'sopMocId',
            // MOC 번호
            label: 'LBLMOCNO',
            align: 'center',
            style: 'width:140px',
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        processCd: '',
        deptCd: '',
        documentClassCd: '',
        documentTitle: '',
        useFlag: 'Y',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.psi.document.list.url;
      this.getList();
      
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.searchParam.documentClassCd = this.documentInfo.documentClassCd;
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    detailPopup(result) {
      this.popupOptions.target = () =>
      import(`${"./documentMasterDetail.vue"}`);
      this.popupOptions.title = this.documentInfo.title + this.$comm.getLangLabel('LBLDETAIL'); // + 상세
      this.popupOptions.param = {
        psiDocumentId: result ? result.psiDocumentId : null,
        documentClassCd: this.documentInfo.documentClassCd,
        title: this.documentInfo.title
      };
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
